import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import useScreen from 'hooks/useScreen'

const useBreadcrumbs = () => {
    const params = useParams()
    const navigation = useSelector((state) => state.navigation)
    const { pageData } = useScreen()
    const pageTitle = pageData?.data?.title
    const { main: navigationMain = [] } = navigation || {}
    const { url1, url2, url3 } = params

    const [breadcrumbs, setBreadcrumbs] = useState([])

    useEffect(() => {
        const newBreadcrumbs = []

        // Siempre incluir inicio
        newBreadcrumbs.push({
            title: 'inicio',
            slug: '/inicio',
            active: !url1, // activo solo si estamos en inicio puro
        })

        const url1data = navigationMain.find((item) => item.slug === url1)

        // Nivel 1
        if (url1) {
            newBreadcrumbs.push({
                title: url1data?.label || url1,
                slug: `/${url1}`,
                active: !url2, // activo solo si no hay url2
            })
        }

        // Nivel 2
        if (url2) {
            newBreadcrumbs.push({
                title: pageTitle || url2,
                slug: `/${url1}/${url2}`,
                active: !url3, // activo solo si no hay url3
            })
        }

        // Nivel 3 (opcional)
        if (url3) {
            newBreadcrumbs.push({
                title: url3,
                slug: `/${url1}/${url2}/${url3}`,
                active: true, // el más profundo siempre activo
            })
        }

        setBreadcrumbs(newBreadcrumbs)
    }, [url1, url2, url3, navigationMain, pageTitle])

    return breadcrumbs
}

export default useBreadcrumbs
